<template>
    <Dialog class="w-full relative border-none" modal v-if="!hintStartPopupApp" :onHide="closePopup"
        v-model:visible="startSlider" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem', getClass('bg')">

        <template #closebutton>
            <Button :label="buttons[lang_].skip" @click="closePopup" icon="pi pi-angle-right" iconPos="right" text rounded class="text-green-400"/>
        </template>

        <template #header>
            <SelectButton v-model="activeLang" :options="langs" optionLabel="label" optionValue="index"  dataKey="title" size="small" class="" @click="setLang">
                <template #option="slotProps">
                    <span class="text-sm py-1 white-space-nowrap">{{ slotProps.option.label }}</span>
                </template>
            </SelectButton>
        </template>

        <div v-for="slide in slides" :class="(slide.active) ? 'flex' : 'hidden'"
            class="flex-column align-items-center justify-content-end h-full">
            <img :src="slide.img" class="w-full flex mb-3" />
            <span class="text-3xl font-medium mb-5 text-center" :class="getClass('text')">
                {{ slide.title[lang_] }}
            </span>
        </div>

        <template #footer>
            <Button v-if="isLastSlide" @click="showVideo()" :label="buttons[lang_].watch" class="w-full border-round-2xl border-none" :class="getClass('btn')" size="large"/>
            <Button @click="next()" :label="getBtnText()" class="w-full border-round-2xl border-none" :class="getClass('btn')" size="large"/>
        </template>
    </Dialog>
    
    <Dialog v-model:visible="showToCreateTransfer" :header="buttons[lang_].header" modal blockScroll
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full' : ''"
        class="w-full" style="max-width: 800px">
        <div v-if="isTgApp">
            <iframe width="100%" height="500" src="https://www.youtube.com/embed/6B7hKQL9d5c" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div v-else>
            <iframe v-if="(screen_size=='sm' || screen_size=='xs')" width="100%" height="500" src="https://www.youtube.com/embed/sMwYNxul8yQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <iframe v-else width="100%" height="315" src="https://www.youtube.com/embed/sMwYNxul8yQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </Dialog>
</template>

<script>
import { useCookies } from "vue3-cookies"
import Connect from '@/assets/js/Connect.js'
import Helper from '@/assets/js/Helper.js'

export default {
    name: 'HintStartPopup',
    data() {
        return {
            cookies: useCookies(),
            startSlider: true,
            showToCreateTransfer: false,
            activeLang: null,
            langs: [
                {
                    "label": 'En',
                    "index": "en"
                },
                {
                    "label": "Ру",
                    "index": "ru"
                }
            ],
            slides: [
                {
                    "title": {
                        "en": "Make transfers to another country in 15 minutes",
                        "ru": "Совершайте переводы за 15 минут в другую страну"
                    },
                    "btn": {
                        "en": "Next",
                        "ru": "Далее"
                    },
                    "img": "/images/slides/slide1.png",
                    "textClass": "text-green-600",
                    "bgClass": "bg-green-100",
                    "btnClass": "bg-green-500 text-white",
                    "headerColor": "#aeee83",
                    "active": true,
                },
                // {
                //     "title": {
                //         "en": "Get a card for online purchases abroad for just $1",
                //         "ru": "Получите карту для онлайн покупок за рубежом всего за 1$"
                //     },
                //     "btn": {
                //         "en": "Next",
                //         "ru": "Далее"
                //     },
                //     "img": "/images/slides/slide2.png",
                //     "textClass": "text-green-100",
                //     "bgClass": "bg-green-500",
                //     "btnClass": "bg-green-100 text-green-500",
                //     "headerColor": "#548B31",
                //     "active": false,
                // },
                {
                    "title": {
                        "en": "How to make a transfer via PayWave? Watch the video",
                        "ru": "Как сделать перевод через PayWave? Смотрите видео"
                    },
                    "btn": {
                        "en": "Close",
                        "ru": "Закрыть"
                    },
                    "img": "/images/slides/slide3.png",
                    "textClass": "text-green-600",
                    "bgClass": "bg-green-100",
                    "btnClass": "bg-green-500 text-white",
                    "headerColor": "#aeee83",
                    "active": false,
                }
            ],
            buttons:  {
                ru:{
                    header: 'Как сделать перевод',
                    skip: "Пропустить",
                    watch: "Смотреть"
                },
                en:{
                    header: 'How to make a transfer',
                    skip: "Skip",
                    watch: "Watch"
                }              
            },
            activeSlide: 0,
        }
    },
    computed: {
        lang_() { return this.$store.getters.StateLang },
        screenSize() { return this.$store.getters.StateScreenSize },
        hintStartPopupApp() { return this.$store.getters.StateStartPopupForApp },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isLastSlide() {
            return this.activeSlide === this.slides.length - 1;
        }
    },
    methods: {
        async closePopup() {
            try{
                await this.$store.dispatch('sawStartPopupForApp', true).then(() => {})
            } catch {}
            this.cookies.cookies.set("sawStartPopupForApp", true)
            localStorage.setItem('sawStartPopupForApp', true)
            this.startSlider = false
            try{
                this.helper.SetTgAppHeadColor('white', false)
            } catch (e) {
                console.error('Error setting head color:', e);
            }
        },
        async showVideo() {
            this.startSlider = false
            this.showToCreateTransfer = true
        },
        next(){
            const length = this.slides.length;
            if(this.activeSlide >= length - 1) {
                this.startSlider = false;
                this.closePopup();
                return;
            }
            this.activeSlide++;
            this.slides.forEach((slide, index) => {
                slide.active = index === this.activeSlide;
            });
        },
        getClass(type) {
            try{
                return this.slides[this.activeSlide][`${type}Class`];
            } catch (e) {
                console.error('Error getting class:', e);
                return '';
            }
        },
        getBtnText() {
            return this.slides[this.activeSlide].btn[this.lang_];
        },
        async changeLang(lang) {
            this.$i18n.locale = lang
            this.local = lang
            try { await this.$store.dispatch('SetLang', lang).then(() => {}) } 
            catch { console.log('error store lang') }
        },
        setLang(){
            if(!this.activeLang) this.activeLang = this.lang_
            if(this.activeLang == this.lang_) return
            this.changeLang(this.activeLang)
        }
    },
    watch: {
        activeSlide(newVal) {
            if(this.slides[newVal]) {
                try{
                    this.helper.SetTgAppHeadColorCustom(this.slides[newVal].headerColor)
                } catch (e) {
                    console.error('Error setting head color:', e);
                }
            }
        },
    },
    beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.activeLang = this.lang_
        try{
            if(!this.hintStartPopupApp) this.helper.SetTgAppHeadColorCustom('#aeee83') // first slide color
            else this.helper.SetTgAppHeadColor('white', false)
        } catch (e) {
            console.error('Error setting head color:', e);
        }
    },
}
</script>